import { render, staticRenderFns } from "./ScatterChart.vue?vue&type=template&id=06af6ea2"
import script from "./ScatterChart.vue?vue&type=script&lang=js"
export * from "./ScatterChart.vue?vue&type=script&lang=js"
import style0 from "./ScatterChart.vue?vue&type=style&index=0&id=06af6ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports